<script setup>
import { computed } from 'vue'
import Button from './Components/Button.vue';

const props = defineProps({ status: Number })
const title = computed(() => {
  return {
    503: 'Onderhoud',
    500: 'Server Error',
    404: 'Pagina niet gevonden',
    403: 'Geen toegang',
  }[props.status]
})

const description = computed(() => {
  return {
    503: 'Sorry, we zijn op dit moment in onderhoud. We zijn spoedig weer online!',
    500: 'Oeps! Er is iets misgegaan aan onze kant. Probeer het later opnieuw.',
    404: 'Sorry, de pagina waar je naar op zoek bent bestaat niet.',
    403: 'Sorry, je hebt niet de benodigde rechten om deze pagina te bezoeken.',
  }[props.status]
})
</script>

<template>
    <main class="grid min-h-full place-items-center bg-white pt-20 lg:px-8">
        <div class="text-center py-20 md:py-28 px-4">
        <p class="text-base font-semibold text-tan">Status: {{props.status}}</p>
        <h1 class="mt-4 text-balance text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl">{{ title }}</h1>
        <p class="mt-6 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">{{ description }}</p>
        <div class="mt-10 flex items-center justify-center gap-x-6" v-if="props.status != 503">
            <Button type="href" class="primary-button" href="/">Naar home</Button>
        </div>
        </div>
    </main>
</template>